import { Box, ButtonBase, useTheme } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useSelector } from "react-redux";
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";
import { selectUser } from "../../../../newapi/user/authentication/authSlice";
import { tokens } from "../../../../theme";
import Business from "./views/Business";

import Icon from "../../../../components/theme/icons/Icon";

import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { relationSettingsDetailsConfig } from "./relationSettingsDetailsConfig";
import { useTranslation } from "react-i18next";
import { useTopbar } from "../../../../contexts/TopbarProvider";
const RelationSettingsDetails = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { showExtraTitle,clearExtraTitle } = useTopbar();

    useEffect(() => {
        showExtraTitle(t("details"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box 
            sx={{
                background:"", 
                width:1,
                paddingTop:9,
                position:"relative",
                "@media screen and (max-width:47.9375em)" : {
                        background:"", 
                    width:1,
                    marginTop:9,
                    height: "calc(100% - 72px)",
                    // position:"relative",
                    paddingX:4,
                    paddingTop:4,
                    overflow:"hidden",
                    display:"flex",
                    flexDirection:"column",
                    
                },
                "@media screen and (max-width: 47.9375em)" : {
                    paddingX:0,
                    paddingTop:0,
                    background:colors.bg["tertiary"],
                    "&:before,&:after":{
                        display:"none"
                    }
                },
            }}
        >
            <TabView3
                tabConfig={relationSettingsDetailsConfig}
                // viewType="bodytabs"
                sx={{
                    minHeight:"calc(100%)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,
                    height:1,
                    display:"flex",
                    flexDirection:"column",
                    // "@media screen and (max-width: 47.9375em)" : {
                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"48px",
                            position:"absolute",
                            left:0,
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },
        
                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"48px",
                            position:"absolute",
                            top:"40px",
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            right:0,
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },
                        "@media screen and (max-width: 47.9375em)" : {

                            "&:before, &:after" : {
                                top:0,
                                width:"24px",
                                // height:"24px",
                            }
                        }
                    // }
                  
                }}
            >
                <>
                    <Business config={relationSettingsDetailsConfig.business}/>
                </>
            </TabView3>

        </Box>
    )
};

export default RelationSettingsDetails;